import { useContext } from "react";
import { DeliveryFoodContext } from "../../../../DeliveryFoodContext";
import { DeliveryFoodItemCommissaryCell } from "../../../../types/DeliveryFoodTypes";
import DeliveryFoodCell from "../../DeliveryFoodCell";

export const DeliveryFoodItemCommissaryPrepCell = ({
    config,
}: {
    config: DeliveryFoodItemCommissaryCell;
}) => {
    const { deliveryFoodState } = useContext(DeliveryFoodContext);
    const { commissary, index, ingredient } = config;

    if (deliveryFoodState.mode.display.COM.prep === false) {
        return null;
    }

    const key = `prep-cell-${index}`;
    const commissaryId: string | number = commissary.data?.id || "";

    if (!commissaryId) {
        return null;
    }

    if (!ingredient.results.COM) {
        return null;
    }

    const summary = ingredient.results.COM.prep;

    if (!summary) {
        return null;
    }

    return (
        <DeliveryFoodCell
            key={key}
            fieldName={"prep"}
            styleName={"PREP"}
            summary={summary}
            index={index}
            ingredient={ingredient}
            restaurant={commissary}
        />
    );
};
